const initialState = {
  dataSearchListClaimRecon: {
    storedValues: {
      noClaim: "",
      refId: "",
      insurer: "",
      product: "",
      maxSumInsured: "",
      minSumInsured: "",
      maxNetPremium: "",
      minNetPremium: "",
      minExpiredDate: "",
      maxExpiredDate: "",
      minClaimLastUpdateDate: "",
      maxClaimLastUpdateDate: "",
    },
    storedPage: 1,
  },
};

const claimReconReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_DATA_SEARCH_LIST_CLAIM_RECON":
      return {
        ...state,
        dataSearchListClaimRecon: action.payload,
      };
    case "RESET_LIST_CLAIM_RECON":
      return (state = initialState);

    default:
      return state;
  }
};

export default claimReconReducer;
